<template>
  <SPCoreShell>
    <template #filter>
      <v-select class="mb-4" v-model="liveFilters.provider" :items="filterListData.prescriberList" item-text="name" item-value="id" label="Prescriber Provider" multiple outline hide-details />
      <v-select class="mb-4" v-model="liveFilters.payer" :items="filterListData.payerList" item-text="name" item-value="id" label="Payer" multiple outline hide-details />
      <v-select class="mb-4" v-model="liveFilters.spp" :items="filterListData.sppList" item-text="name" item-value="id" label="Specialty" multiple outline hide-details />
      <v-treeselect class="spcore-states-treeselect" :value="selectedStates" :multiple="true" :options="states" placeholder="State" @input="stateSelected" />
      <loader v-if="isFiltering.filterList" />
    </template>
    <div class="overflow-hidden w-100">
      <div class="grow-1 p-4" style="overflow: auto">
        <div class="hvh-flex space-between mb-3">
          <h2>Prescriber</h2>
          <a @click="exportCSV">Export CSV <v-icon>mdi-clipboard-arrow-up</v-icon></a>
        </div>
        <div class="hvh-flex space-between mb-4">
          <div class="hvh-flex align-center">
            <span class="menu-button selected">Open</span>
            <span class="menu-button">Archived</span>
          </div>
        </div>
        <v-data-table :headers="headers" :items="providerListData" must-sort :pagination.sync="pagination" ref="dt">
          <template slot="items" slot-scope="{ item }">
            <tr>
              <td>
                <router-link :to="{ name: 'spcoreProvider', params: { id: item.patientID } }">{{ item.patientID }}</router-link>
              </td>
              <td>
                <spcore-risk :value="item.risk" />
              </td>
              <td>
                <div style="width: 20px; height: 20px; border-radius: 100%; background-color: #002f6c; color: white; text-align: center">{{ item.alert }}</div>
              </td>
              <td>{{ item.nexT_BEST_ACTION }}</td>
              <td>{{ item.piq }}</td>
              <td>{{ item.updated }}</td>
              <td>{{ item.specialty }}</td>
              <td>{{ item.city }}</td>
              <td>{{ item.address }}</td>
              <td>{{ item.product }}</td>
            </tr>
          </template>
          <div slot="no-data" :value="true" type="warning">There are no items to show.</div>
        </v-data-table>
      </div>
    </div>
  </SPCoreShell>
</template>

<script>
import axios from '../../axios';
import { getDemographics } from '../../libraries/cohorts';
import { isString, mergeFilters, sanitize } from '../../libraries/common';
import { saveAs } from 'file-saver';
import SPCoreShell from '../../components/spcore/SPCoreShell.vue';
import VTreeselect from '@riophae/vue-treeselect';
export default {
  title: 'Provider List',
  components: { SPCoreShell, VTreeselect, },
  data() {
    var states = getDemographics().states
      .reduce((acc, f) => { acc[f.value] = f.text; return acc; }, {});
    return {
      liveFilters: { area: {} },
      isFiltering: {},
      cancelRequest: {},

      headers: [
        { text: 'NAME', align: 'left', value: 'firstName', class: ['text-xs-left hvh-table-header width-40'] },
        { text: 'Risk', align: 'left', value: 'risk', class: ['text-xs-left hvh-table-header'] },
        { text: 'Alert', align: 'left', value: 'alert', class: ['text-xs-left hvh-table-header'] },
        { text: 'Next Best Action', align: 'left', value: 'NEXT_BEST_ACTION', class: ['text-xs-left hvh-table-header'] },
        { text: 'PIQ', align: 'left', value: 'piq', class: ['text-xs-left hvh-table-header'] },
        { text: 'Updated', align: 'left', value: 'updated', class: ['text-xs-left hvh-table-header'] },
        { text: 'Specialty', align: 'left', value: 'specialty', class: ['text-xs-left hvh-table-header'] },
        { text: 'City', align: 'left', value: 'city', class: ['text-xs-left hvh-table-header'] },
        { text: 'Address', align: 'left', value: 'address', class: ['text-xs-left hvh-table-header'] },
        { text: 'Product', align: 'left', value: 'product', class: ['text-xs-left hvh-table-header'] },
      ],
      pagination: { 'sortBy': 'startTime', 'descending': true, 'rowsPerPage': 25 },
      filterListData: {},
      providerListData: [],
      states: ['Mid West', 'North East', 'South East', 'South West', 'West']
        .map(region => ({
          id: region,
          label: region,
          children: getDemographics()[region]
            .map(f => ({ id: f, label: states[f] }))
        })),
      selectedStates: null,
    }
  },
  methods: {
    mergeFilter(obj) {
      return mergeFilters(this.liveFilters, obj);
    },
    loadFilterListData() {
      if (this.cancelRequest.filterList)
        this.cancelRequest.filterList();
      this.$set(this.isFiltering, 'filterList', true);
      axios.post('/SPCore/providerList/GetProviderList', {
        runId: this.runId,
        ProviderListComponent: "FilterListData",
      }, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest.filterList = c)
      }).then((response) => {

        this.filterListData = response.data;
        this.isFiltering.filterList = false;
      }).catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
          this.isFiltering.filterList = false;
          this.disableIfTimeout(error);
        }
      });
    },
    loadProviderListView() {
      if (this.cancelRequest.providerList)
        this.cancelRequest.providerList();
      this.$set(this.isFiltering, 'patientsList', true);
      axios.post('/SPCore/providerList/GetProviderList', {
        runId: this.runId,
        ProviderListComponent: "ProviderListView",
      }, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest.providerList = c)
      }).then((response) => {

        this.providerListData = response.data;
        this.isFiltering.providerList = false;
      }).catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
          this.isFiltering.providerList = false;
          this.disableIfTimeout(error);
        }
      });
    },
    stateSelected(event) {
      var states = event.map(f => this.states.find(g => g.id === f) || f)
        .flatMap(f => f.children || [f])
        .map(f => f.id || f);
      this.liveFilters = {
        ...this.liveFilters,
        area: {
          ...this.liveFilters.area,
          states
        }
      };
    },
    disableIfTimeout(error) {
      if (error.response.status === 504) {
        this.alert('Error', 'Loading of data failed. Please reload page to try loading data again.');
      }
    },
    exportCSV() {
      var result = [
        this.headers.map(f => f.text).join(','),
        ...this.$refs.dt.filteredItems
          .map(f => this.headers.map(header => {
            var val = f[header.value];
            return isString(val) && val.indexOf(',') > -1 ? `"${val}"` : val;
          }).join(','))
      ];
      var blob = new Blob([result.join('\n')], { type: "text/plain;charset=utf-8" });
      saveAs(blob, sanitize(`Patient List ${this.browserDateTime(new Date()).replaceAll('/', '-').replaceAll(':', '-')}.csv`));
    },
  },
  computed: {
    isFilteringAny() {
      return Object.keys(this.isFiltering).find(key => this.isFiltering[key]);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisSPCoreProviderList'] = this;
    this.loadFilterListData();
    this.loadProviderListView();
  },
}
</script>

<style lang="scss" scoped>
.menu-button {
  padding: 5px 12px;

  &.selected {
    border-radius: 7px;
    background-color: #cce3e7;
  }
}
</style>